module.exports = __webpack_public_path__ + "static/media/gamesPlayed_250000_500000.76b6fa34.png";